/**
 * Platform detection for Capacitor native vs browser.
 *
 * When running in browser (no Capacitor), all flags are false/web.
 * When Capacitor packages are installed and running native, detects platform.
 *
 * NOTE: We check window.Capacitor (injected by native shell) rather than
 * importing @capacitor/core, so this file works without Capacitor installed.
 */

const cap = typeof window !== 'undefined' && window.Capacitor;

export const isNative = cap ? cap.isNativePlatform() : false;
export const isIOS = cap ? cap.getPlatform() === 'ios' : false;
export const isAndroid = cap ? cap.getPlatform() === 'android' : false;
export const isWeb = !isNative;

export function requiresNative(featureName) {
  if (!isNative) {
    console.warn(
      `[DuoFit] Feature "${featureName}" requires a native build. ` +
        'Running in browser — falling back to web implementation.'
    );
    return false;
  }
  return true;
}
